<template>
  <div :class="bem()">
    <SupportTopLevelCategory
      v-for="category in categories"
      :ref="`category${category.id}`"
      :key="category.id"
      :category="category"
    />
  </div>
</template>

<script>
export default {
  name: 'SupportCategories',

  props: {
    categories: {
      type: Array,
      required: true,
    },
    articles: {
      type: Array,
      required: true,
    }
  },

  async setup() {
    const bem = useBEM('SupportCategories')

    return {
      bem,
    }
  },

  data() {
    return {
      activeArticleId: null,
    }
  }
}
</script>

<style lang="postcss">
.SupportCategories {
  @apply grid auto-rows-auto gap-x-4 sm:gap-x-6 gap-y-4 sm:gap-y-6 md:grid-cols-3;
}
</style>